import { render, staticRenderFns } from "./meeting-card.vue?vue&type=template&id=5932c7c8&scoped=true&"
import script from "./meeting-card.vue?vue&type=script&lang=js&"
export * from "./meeting-card.vue?vue&type=script&lang=js&"
import style0 from "./meeting-card.vue?vue&type=style&index=0&id=5932c7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5932c7c8",
  null
  
)

component.options.__file = "meeting-card.vue"
export default component.exports